import gql from "graphql-tag";

export const knowledgeBaseItemsQuery = gql`
  query knowledgeBaseItems(
    $parentId: ID
    $audience: KnowledgeBaseUserAudience
    $nameContains: String
  ) {
    knowledgeBaseItems(parentId: $parentId, audience: $audience, nameContains: $nameContains) {
      id
      name
      parentId
      position
      visibleForDealers
      __typename
      ... on Article {
        type
        content
      }
    }
  }
`;

export const knowledgeBaseSectionsQuery = gql`
  query knowledgeBaseSections($parentId: ID) {
    knowledgeBaseSections(parentId: $parentId) {
      id
      name
      parentId
    }
  }
`;
